import { render, staticRenderFns } from "./ViewResult.vue?vue&type=template&id=de8c1338"
import script from "./ViewResult.vue?vue&type=script&lang=js"
export * from "./ViewResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8c1338')) {
      api.createRecord('de8c1338', component.options)
    } else {
      api.reload('de8c1338', component.options)
    }
    module.hot.accept("./ViewResult.vue?vue&type=template&id=de8c1338", function () {
      api.rerender('de8c1338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/dynamic_attribution/ViewResult.vue"
export default component.exports